import {
  EMAIL_VALIDITY_ERROR_CODES,
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  REGX,
} from "./const";
import { getDomainFromEmail } from "./domain";
import { http } from "./http";
import { LAMBDA_ENTITIES, LAMBDA_FUNCTION_NAMES, getLambdaUrl } from "./lambdaHelpers";

/**
 * Local part (username) of an email address — the slice before "@".
 * Null-safe: a missing/non-string input yields "" rather than throwing,
 * so callers don't need to pre-wrap with `String(x || "")`.
 */
export const getUserNameFromEmail = email => String(email || "").split("@")[0];

async function checkEmailAvailability(payload) {
  const lambdaUrl = getLambdaUrl(
    LAMBDA_ENTITIES.NEO,
    LAMBDA_FUNCTION_NAMES.CHECK_EMAIL_AVAILABILITY
  );
  return new Promise((resolve, reject) => {
    new http().postData(lambdaUrl, { payload }, {}, resolve, reject);
  });
}

export const emailAvailabilityStatus = async emailAddress => {
  const email = emailAddress.toLowerCase();
  const username = getUserNameFromEmail(email);
  let res;
  try {
    res = await checkEmailAvailability(
      { emails: [email], domainName: getDomainFromEmail(email) },
      {}
    );
  } catch (e) {
    console.error(e);
  }

  if (!res) {
    return {
      isAvailable: false,
      errorCode: EMAIL_VALIDITY_ERROR_CODES.NETWORK_ERROR,
    };
  }

  const { availabilityStatus: { [email]: { isAvailable, reason } } = {} } = res;
  if (isAvailable) return { isAvailable, errorCode: "" };
  if (EMAIL_VALIDITY_ERROR_CODES[reason]) {
    return {
      isAvailable,
      errorCode: EMAIL_VALIDITY_ERROR_CODES[reason],
      values: { username },
    };
  }
  return {
    isAvailable,
    errorCode: EMAIL_VALIDITY_ERROR_CODES.DEFAULT,
    values: { username },
  };
};

export const validatePassword = password => {
  const passwordLength = password.length;
  const isSmallPassword = passwordLength < PASSWORD_MIN_LENGTH;
  const isLargePassword = passwordLength > PASSWORD_MAX_LENGTH;
  const isPatternMatching = REGX.password.test(password);

  return {
    isSmallPassword,
    isLargePassword,
    isPatternMatching,
  };
};
